var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAS0lEQVR42mMYBTQG////PwPCZGvesnkzGIPYZGnu6e4GYbghRDkXTTO6IXCMzQD3lpaWLhAGctOwYZg8Qg0mUIFjCMCrZjSZUQkAAAhtXrlkUCmaAAAAAElFTkSuQmCC";
  export default img;